













import { Vue, Component, Prop } from 'vue-property-decorator';
import {UserProfile} from "../../../api/models/UserProfile";
import UserIcon from "../../../share/common/UserIconSettings.vue";
import AccountGear from "../../../assets/svg/account-gear.svg";
import {RepositoryFabric} from "../../../api/repositories/RepositoryFabric";
import {FileRepository} from "@api/repositories/FileRepository";

@Component({
    name: 'Photo',
    components: { UserIcon, AccountGear }
})
export default class Photo extends Vue {
    @Prop() profile: UserProfile;
    photoId = '';
    photoInput: HTMLInputElement|null = null;
    fileRepository: FileRepository = this.$repositories.get(RepositoryFabric.FILE);
    defaultFileSizeLimit = 3;
    showValidationMessage = false;
    validationMessage = ""
    allowedExtensions = ['gif', 'jpg', 'jpeg', 'png']

    async mounted() {
        this.photoInput = this.$el.querySelector('#userProfilePhoto') as HTMLInputElement;
    }

    async changePhoto() {
        this.photoInput?.click();
    }

    async fileSelected() {
        if (this.photoInput?.files && this.photoInput?.files[0] !== undefined) {

            const file = this.photoInput?.files[0];
            const valid = this.validate(file);

            if(!valid) {
                this.showValidationMessage = true;
                return
            }

            this.showValidationMessage = false;

            const newPhoto = await this.fileRepository.create(file, file.name);
            this.$emit('photo-changed', newPhoto);
        }
    }

    validate(file: File): boolean {
        const sizeLimitMB = this.fileSizeLimit;
        const sizeLimitByte = sizeLimitMB * Math.pow(1024, 2);
        const extMatch = file.name.match(/\.([^.]+)$/);
        const ext = extMatch && extMatch[1];

        if(ext && this.allowedExtensions.indexOf(ext.toLowerCase()) === -1) {
            this.validationMessage = `${this.$t("settings.fileTypeValidationMessage")}: ${this.allowedExtensions.join(', ')}`;
            return false
        }

        if(file.size > sizeLimitByte) {
            this.validationMessage = `${this.$t("settings.photoSizeLimit")} ${this.fileSizeLimit} ${this.$t("common.megaByte")}`;
            return false
        }

        return true;
    }

    get fileSizeLimit() {
        const limitFromConfig = process.env.VUE_APP_IMAGE_MAX_SIZE_MB;

        if(!limitFromConfig) {
            return this.defaultFileSizeLimit;
        }

        const limitMB = parseFloat(limitFromConfig);

        return !isNaN(limitMB) ? limitMB : this.defaultFileSizeLimit;
    }
}
